import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit';

import mapsReducer from './maps.reducer';
import devicesReducer from './devices.reducer';
import userReducer from './user.reducer';
import organizationsReducer from './organizations.reducer';
import onboardDeviceHardwareConfigurationsReducer from './onboardDeviceHardwareConfigurations.reducer';
import activationSticksReducer from './activationSticks.reducer';
import systemConfigurationsReducer from './systemConfigurations.reducer';
import onboardDevicesOnlinePeersReducer from './onboardDevicesOnlinePeers.reducer';
import routeCardsReducer from './routeCards.reducer';
import routeCardTemplatesReducer from './routeCardTemplates.reducer';

export const store = configureStore({
    reducer: {
        maps: mapsReducer,
        devices: devicesReducer,
        user: userReducer,
        organizations: organizationsReducer,
        onboardDeviceHardwareConfigurations: onboardDeviceHardwareConfigurationsReducer,
        activationSticks: activationSticksReducer,
        systemConfigurations: systemConfigurationsReducer,
        onboardDevicesOnlinePeers: onboardDevicesOnlinePeersReducer,
        routeCards: routeCardsReducer,
        routeCardTemplates: routeCardTemplatesReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
